import { useT } from "@/i18n/I18nProvider";

/**
 * Structural block used across detail pages where the official copy is not
 * yet available. Communicates "pending official release" instead of
 * inventing corporate content.
 */
export function PendingContentBlock({ label, testId }: { label?: string; testId?: string }) {
  const { t } = useT();
  return (
    <div
      className="border-l-2 border-clay pl-6 py-2"
      data-testid={testId ?? "pending-content"}
      role="note"
    >
      <p className="eyebrow mb-2 !text-clay">{label ?? t.sections.overviewLabel}</p>
      <p className="text-ink text-lg md:text-xl font-display font-light leading-snug">
        {t.sections.contentPending}
      </p>
      <p className="mt-2 text-sm text-slate2 max-w-prose-tight">
        {t.sections.contentPendingHint}
      </p>
    </div>
  );
}
